import React from "react";

import BrandButton from "@/common/BrandButton/BrandButton";
import BrandModal from "@/common/Modal/BrandModal";
import Text from "@/common/Text/Text";
import styles from "./ReleasesDeleteModal.module.scss";

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ReleasesDeleteModal: React.FC<Props> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  return (
    <BrandModal
      title="Are you sure you want to delete APK(s)?"
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      <div className={styles.container}>
        <Text size="md" className={styles.description}>
          This action is irreversible and will permanently remove the file(s).
          Please confirm to proceed.
        </Text>

        <div className={styles.buttonContainer}>
          <BrandButton
            size="sm"
            onClick={onConfirm}
            className={styles.deleteButton}
          >
            Delete
          </BrandButton>
        </div>
      </div>
    </BrandModal>
  );
};

export default ReleasesDeleteModal;
